<template>
    <div>
        <vue-simple-suggest
                pattern="\w+"
                v-model="selecao"
                :list="getData"
                mode="select"
                :min-length="3"
                :max-suggestions="0"
                :display-attribute="options.text"
                :value-attribute="options.value"
                :debounce="1000"
                @select="emit"
                :filter-by-query="true"
                ref="suggest">

            <div class="g">
                <input type="text" :class="classe" :placeholder="placeholderAt ? placeholderAt : placeholder">
            </div>

            <template slot="misc-item-above" slot-scope="{ suggestions, query }">
                <div class="misc-item">
                    <span>Procurando por: '{{ query }}'.</span>
                    <span style="color: red; float: right; cursor: pointer">
                        <button class="btn btn-primary" @click.prevent="hideList">
                            Fechar
                            <i class="fa fa-close"></i>
                        </button>
                    </span>
                </div>

                <template v-if="suggestions.length > 0">
                    <div class="misc-item">
                        <span>{{ suggestions.length }} sugestões exibidas...</span>
                    </div>
                    <hr>
                </template>

                <div class="misc-item" v-else-if="!loading">
                    <span>Nenhuma correspondência</span>
                </div>
            </template>

            <div class="misc-item" slot="misc-item-below" slot-scope="{ suggestions }" v-if="loading">
                <vue-element-loading :active="true" spinner="bar-fade-scale"/>
            </div>

        </vue-simple-suggest>
    </div>
</template>

<script>
    import 'vue-simple-suggest/dist/styles.css';

    export default {
        data() {
          return {
              selecao: null,
              data: Array,
              loading: false,
              placeholderAt: '',
          }
        },
        props: {
            url:         String,
            options:     Object,
            placeholder: String,
            error:       Boolean,
            classe:      String,
            manipulate:  { type: Function }
        },
        methods: {
            emit()
            {
                if (this.selecao)
                {
                    this.$emit('changeData', this.selecao);
                }
            },
            getData(value)
            {
                this.$refs.suggest.clearSuggestions();
                this.loading = true;
                
                return new Promise((resolve) => {
                    this.axios.get(this.url, {params: {term: value}}).then((result) => {

                        if (result.data.records instanceof Object)
                        {
                            result.data.records = Object.values(result.data.records);
                        }

                        if (this.manipulate)
                        {
                            resolve(this.manipulate(result));
                        }
                        else
                        {
                            resolve(result);
                        }

                        this.loading = false;
                    })
                })
            },
            clearInput()
            {
                if (this.selecao)
                {
                    const el = document.getElementsByClassName('input-field-post')[0];

                    if (el)
                    {
                        el.value = '';
                    }

                    this.$refs.suggest.text = '';
                    this.placeholderAt = this.selecao.descricao;
                }
            },
            hideList()
            {
                this.$refs.suggest.hideList();
            },
            handleScrollClick(event) {
                if (event.target.classList.contains('suggestions')) {
                    event.preventDefault();
                }
            },
        },
        updated()
        {
            this.clearInput()
        },
        mounted()
        {
            // Esse trecho foi aplicado para evitar que a lista feche ao clicar no scrollbar
            const selectProductList = this.$refs.suggest?.$el
            if(selectProductList) {
                selectProductList.addEventListener('mousedown', this.handleScrollClick);
            }
        },
        beforeDestroy() {
            const selectProductList = this.$refs.suggest?.$el
            if(selectProductList) {
                selectProductList.removeEventListener('mousedown', this.handleScrollClick);
            }
        },
    };
</script>